import type { ReactNode } from "react"
import { Link } from "wouter"
import styles from "./Button.module.scss"
import cx from "clsx"

type Props = {
  href: string
  variant?: "primary" | "secondary" | "tertiary"
  children: ReactNode
  className?: string
  onClick?: () => void
}

export function ButtonLink({
  href,
  variant = "primary",
  children,
  className,
  onClick,
}: Props) {
  return (
    <Link
      href={href}
      className={cx(styles.button, styles[variant], className)}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}
